// extracted by mini-css-extract-plugin
export default {"textarea":"textarea__textarea--hlSNK"};